/**
 * Normalizes common GFM list authoring gaps so react-markdown reliably emits `<ul>`/`<ol>`.
 *
 * Pure LLM answers often run prose directly into `- item` without the blank line GFM requires
 * after a paragraph. Streaming deltas can also briefly look like a valid list before the full
 * answer arrives with a different newline shape.
 */
export function normalizeMarkdownLists(text) {
    if (!text || typeof text !== 'string') {
        return text;
    }

    let normalized = text.replace(/\r\n/g, '\n');

    // Prose ending with punctuation then an inline list marker (common after server enrichment).
    normalized = normalized.replace(
        /([:.!?])[ \t]+([-*+]|\d+\.)(\s+)/g,
        '$1\n\n$2$3'
    );

    // Paragraph or heading line immediately followed by a list marker needs a blank line.
    normalized = normalized.replace(
        /^(?!(?:[-*+]|\d+\.)\s)([^\n]+)\n([-*+]|\d+\.)(\s+)/gm,
        '$1\n\n$2$3'
    );

    // Collapse 3+ blank lines (but keep paragraph/list separation).
    normalized = normalized.replace(/\n{3,}/g, '\n\n');

    return normalized;
}

export default normalizeMarkdownLists;
